import ProfileView from "../ProfileView/ProfileView";

const UserView = () => {
    return ProfileView( {newUser: false, myProfile: false})
}

export default UserView